import axios from "axios";
import React, { useState, useEffect } from "react";
import moment from "moment";
import ReportsCriteria from "../../ShortCutComponents/ReportsCriteria";
import { baseurl } from "../../../../baseurl";
import BootstrapTable from "react-bootstrap-table-next";
import paginationFactory, {
  PaginationProvider,
  SizePerPageDropdownStandalone,
} from "react-bootstrap-table2-paginator";
import "react-bootstrap-table-next/dist/react-bootstrap-table2.min.css";
import "./formsTable.css";
import "./baseForms.css";
import Decimal from "../../ShortCutComponents/Decimal";
import { check_Bussiness_Permission } from "../../../../Helper";
import ExportToExcel from "../../SExport/ExportToExcle";
import { Button, Collapse, Table } from "reactstrap";
import swal from "@sweetalert/with-react";
import { generateCriteriaString } from "../../ShortFunction/shortFunctions";

let companyId = localStorage.getItem("companyId");
let username = localStorage.getItem("username");
var token = localStorage.getItem("token");
var companySymbolCurrency = localStorage.getItem("companySymbolCurrency");

export default function AllsuppliersReport(props) {
  const [isLoading, setIsLoading] = useState(false);
  const [showtable, setshowtable] = useState(false);
  const [showAsInteger, setShowAsInteger] = useState(false);

  const formatWithDrCr = (amount) => {
    const numAmount = Number(amount);
    const formattedAmount = Math.abs(numAmount).toLocaleString("en-US", {
      maximumFractionDigits: showAsInteger ? 0 : 2,
      minimumFractionDigits: showAsInteger ? 0 : 2,
    });

    if (numAmount > 0) {
      return `${formattedAmount} Dr`;
    } else if (numAmount < 0) {
      return `${formattedAmount} Cr`;
    } else {
      return `${formattedAmount}`;
    }
  };
  const due_Formators = (cell, row, enumObject, index) => {
    let newCell = "";
    newCell = cell;
    if (typeof cell === "string") {
      newCell = parseFloat(cell.replace(/,/g, ""));
    }
    if (newCell) {
      newCell = newCell?.toLocaleString("en-US", {
        maximumFractionDigits: showAsInteger ? 0 : 2,
        minimumFractionDigits: showAsInteger ? 0 : 2,
      });

      // newCell = companySymbolCurrency + " " + newCell;
    } else {
      newCell = "0";
    }
    return newCell;
  };
  const [data, setData] = useState({
    criteriaString: "All",
    collapseCriteria: true,
  });

  const [table, setTable] = useState({
    OverViewDataTable: [],
    printData: [],
    listOfData: [],
    listOfColLables: [],
    listOfColKey: [],
    exportData: [],
    totalSumAll: null,
  });

  const [filteredData, setFilteredData] = useState([]);

  // Define columns array
  const columns = [
    {
      dataField: "customer_code",
      text: "Code",
      sort: true,
      footer: "ToTal",
      style: {
        textAlign: "left",
        backgroundColor: "#f8f9fa",
        width: "5%",
      },
      footerStyle: {
        textAlign: "left",
      },
    },
    {
      dataField: "company_name",
      text: "Customer Name",
      sort: true,
      footer: "-",
      style: {
        textAlign: "left",
        backgroundColor: "#f8f9fa",
      },
      footerStyle: {
        textAlign: "left",
      },
    },
    {
      dataField: "opening",
      text: "Opening",
      headerStyle: {
        textAlign: "right",
      },
      sort: true,
      style: {
        textAlign: "right",
        backgroundColor: "#f8f9fa",
      },
      formatter: (cell) => formatWithDrCr(cell),
      footer: () =>
        table.totalSumAll ? formatWithDrCr(table.totalSumAll.opening) : "0.00",
      footerStyle: {
        fontWeight: "bold",
        textAlign: "right",
      },
    },
    {
      dataField: "Debit",
      text: "Debit",
      headerStyle: {
        textAlign: "right",
      },
      sort: true,
      formatter: due_Formators,
      footer: () =>
        table.totalSumAll ? due_Formators(table.totalSumAll.Debit) : "0.00",
      style: {
        textAlign: "right",
        backgroundColor: "#f8f9fa",
      },
      footerStyle: {
        fontWeight: "bold",
        textAlign: "right",
      },
    },
    {
      dataField: "Credit",
      text: "Credit",
      headerStyle: {
        textAlign: "right",
      },
      sort: true,
      formatter: due_Formators,
      footer: () =>
        table.totalSumAll ? due_Formators(table.totalSumAll.Credit) : "0.00",
      style: {
        textAlign: "right",
        backgroundColor: "#f8f9fa",
      },
      footerStyle: {
        fontWeight: "bold",
        textAlign: "right",
      },
    },
    {
      dataField: "closing",
      text: "Closing",
      headerStyle: {
        textAlign: "right",
      },
      sort: true,
      formatter: (cell) => formatWithDrCr(cell),
      footer: () =>
        table.totalSumAll ? formatWithDrCr(table.totalSumAll.closing) : "0.00",
      style: {
        textAlign: "right",
        backgroundColor: "#f8f9fa",
      },
      footerStyle: {
        fontWeight: "bold",
        textAlign: "right",
      },
    },
  ];

  useEffect(() => {
    checkBussinessPermission();
  }, []);
  const checkBussinessPermission = async () => {
    let checkBussinessPermission = await check_Bussiness_Permission();
    console.log("checkBussinessPermission :>> ", checkBussinessPermission[0]);
    let { isDollarjnction } = checkBussinessPermission;
    if (isDollarjnction) {
      setShowAsInteger(true);
    }
  };
  const getAccountsSummary = async (
    fromDate,
    toDate,
    customer_id,
    customer_id2,
    branch_id,
    posBranchmore,
    custCateg_id,
   ) => {
    setIsLoading(true);
    try {
      const fDate = fromDate ? moment(fromDate).format("YYYY-MM-DD") : null;
      const tDate = toDate ? moment(toDate).format("YYYY-MM-DD") : null;
      const response = await axios.post(
        `${baseurl}/repots/customerGLReportsummary`,
        {
          fromDate: fDate,
          toDate: tDate,
          customer_id: customer_id,
          customer_id2: customer_id2,
          // multiPosBranch: branch_id?.id || posBranchmore,
          multiPosBranch: posBranchmore,
          custCateg_id : custCateg_id?.id || custCateg_id || null,
          username,
          companyId,
        },
        {
          headers: { authorization: token },
        },
      );
      const callData = response.data.data;
      processTableData(
        callData,
        fromDate,
        toDate,
        customer_id,
        customer_id2,
        branch_id,
      );
    } catch (error) {
      console.error("Error fetching suppliers report:", error);
      setIsLoading(false);
    }
  };

  const processTableData = (
    callData,
    fromDate,
    toDate,
    customer_id,
    customer_id2,
    branch_id
  ) => {
    let mainScreenData = [];
    let printData = [];
    let exportData = [];

    callData.forEach((element, index) => {
      const Credit = Number(element.Credit) || 0;
      const Debit = Number(element.Debit) || 0;
      const opening = Number(element.opening) || 0;
      const closing = opening + Debit - Credit;

      const rowData = {
        sr: index + 1,
        customer_code: element.customer_code || "",
        company_name: element.company_name || "",
        opening: opening,
        Debit: Debit,
        Credit: Credit,
        closing: closing,
      };

      mainScreenData.push(rowData);

      printData.push({
        sr: rowData.sr,
        customer_code: rowData.customer_code,
        company_name: rowData.company_name,
        opening: formatWithDrCr(opening),
        Debit: due_Formators(Debit),
        Credit: due_Formators(Credit),
        closing: formatWithDrCr(closing),
      });
    });

    const totalSumAll = mainScreenData.reduce(
      (acc, curr) => ({
        opening: acc.opening + curr.opening,
        Debit: acc.Debit + curr.Debit,
        Credit: acc.Credit + curr.Credit,
        closing: acc.closing + curr.closing,
      }),
      {
        opening: 0,
        Debit: 0,
        Credit: 0,
        closing: 0,
      }
    );

    printData.push({
      sr: "Total",
      customer_code: "",
      company_name: "",
      opening: formatWithDrCr(totalSumAll.opening),
      Debit: due_Formators(totalSumAll.Debit),
      Credit: due_Formators(totalSumAll.Credit),
      closing: formatWithDrCr(totalSumAll.closing),
    });

    exportData = [
      {
        sr: "Customer Balances GL Report",
        customer_code: fromDate
          ? `As On ${moment(fromDate).format("DD-MMM-YYYY")}`
          : "All",
        company_name: "",
        opening: "",
        Debit: "",
        Credit: "",
        closing: "",
      },
      {
        sr: `*Note: All figures in company currency (${companySymbolCurrency}). Dr means receivable from supplier and Cr means payable to supplier`,
        customer_code: "",
        company_name: "",
        opening: "",
        Debit: "",
        Credit: "",
        closing: "",
      },
      ...printData,
    ];

    // const listOfColLables = [
    //   "Sr#",
    //   "Customer Code",
    //   "Customer Name",
    //   "Opening",
    //   "Debit",
    //   "Credit",
    //   "Closing",
    // ];

    const listOfColLables = [
      { align: "left", value: "Sr#" },
      { align: "left", value: "Customer Code" },
      { align: "left", value: "Customer Name" },
      { align: "right", value: "Opening" },
      { align: "right", value: "Debit" },
      { align: "right", value: "Credit" },
      { align: "right", value: "Closing" },
    ];
    const listOfColKey = [
      { align: "left", value: "sr" },
      { align: "left", value: "customer_code" },
      { align: "left", value: "company_name" },
      { align: "right", value: "opening" },
      { align: "right", value: "Debit" },
      { align: "right", value: "Credit" },
      { align: "right", value: "closing" },
    ];

    setTable({
      OverViewDataTable: mainScreenData,
      printData,
      listOfData: exportData,
      listOfColLables,
      listOfColKey: listOfColKey,
      exportData,
      totalSumAll: totalSumAll,
      selectedStartDate: fromDate,
      selectedendDate: toDate,
      selectedSupplier: customer_id?.label || "All",
      selectedSupplier2: customer_id2?.label || "All",
      selectedBranch: branch_id?.label || "All",
    });

    setFilteredData(mainScreenData);
    setIsLoading(false);
  };

  const handleFind = (p) => {
    const {
      fromDate,
      toDate,
      customer_id,
      multiCustLabel,
      customer_id2,
      multiCust2Label,
      branch_id,
      posBranchmore,
      multiPosBranchmoreLabel,
      custCateg_id,
    } = p;
    console.log("p", p);

    const critObj = {
      fromDate,
      toDate,
      customer_id,
      customer_id2,
      branch_id : branch_id || posBranchmore,
      multiCustLabel: customer_id?.label|| multiCustLabel,
      multiSupp2Label: customer_id2?.label || multiCust2Label,
      multiPosBranchLabel: branch_id?.label || multiPosBranchmoreLabel,
      multiPosBranch: branch_id,
    };

    const criteriaString = generateCriteriaString(critObj);

    setData({
      ...data,
      criteriaString: criteriaString,
    });

    console.log("criteriaString :>> ", criteriaString);
    console.log("p :>> ", p);
    if (!fromDate || !toDate) {
      const missingField = !fromDate ? "From Date" : "To Date";

      swal({
        title: `Missing ${missingField}`,
        text: `Please select a ${missingField} before continuing.`,
        icon: "warning",
        timer: 2000,
        buttons: false,
      });
      return;
    }
    setshowtable(true);
    getAccountsSummary(
      fromDate,
      toDate,
      customer_id,
      customer_id2,
      branch_id,
      posBranchmore,
      custCateg_id,
    );
  };

  const handleDynamicColapse = (params) => {
    setData((prev) => ({ ...prev, collapseCriteria: params.collapseCriteria }));
  };

  const sendSearchedData = (params) => {
    setFilteredData(params.filteredData);
  };

  const funPrintView = (data1, headers, headerKeyMap) => {
    const {
      selectedStartDate,
      selectedendDate,
      selectedSupplier,
      selectedSupplier2,
    } = table;

    let fromDatee = selectedStartDate
      ? moment(selectedStartDate).format("DD-MMM-YYYY")
      : "All";
    let toDatee = selectedendDate
      ? moment(selectedendDate).format("DD-MMM-YYYY")
      : "All";
    let dateCriteria = [
      { label: "From Date", value: fromDatee },
      { label: "To Date", value: toDatee },
    ];
    const formattedPrintData = table.printData.map((item) => ({
      ...item,
      Debit: due_Formators(item.Debit),
      Credit: due_Formators(item.Credit),
    }));
    let criteria = [
      dateCriteria[0],
      dateCriteria[1],
      { label: "From Customer", value: selectedSupplier },
      { label: "To Customer", value: selectedSupplier2 },
    ];

    console.log("criteria :>> ", criteria);
    // const reportState = {
    //   data: formattedPrintData,
    //   headers: headers,
    //   headerKeyMap: headerKeyMap,
    //   goBackUrl: "/CustomerGLreport",
    //   dynamicInvMessage: "Customer Balances GL Report",
    //   reportName: "Customer_Balances_GL_Report",
    //   criteria,
    //   criteriaString: data.criteriaString,
    // };
    // localStorage.setItem("reportState", JSON.stringify(reportState));
    // window.open("#/PrintReportsNew", "_blank");
    props.history.push({
      pathname: "/PrintReports",
      state: {
        data: formattedPrintData,
        headers: headers,
        headerKeyMap: headerKeyMap,
        goBackUrl: "/CustomerGLreport",
        dynamicInvMessage: "Customer Balances GL Report",
        reportName: "Customer_Balances_GL_Report",
        criteria,
        criteriaString: data.criteriaString,
      },
    });
  };

  const graph = () => {
    swal({
      title: "Coming Soon",
      text: "This feature is under development",
      icon: "warning",
      timer: 2000,
      buttons: false,
    });
  };

  const options = {
    paginationShowsTotal: true,
    page: 1,
    sizePerPage: 10,
    pageStartIndex: 1,
    paginationSize: 5,
    prePage: "Prev",
    nextPage: "Next",
    firstPage: "First",
    lastPage: "Last",
    prePageTitle: "Go to previous",
    nextPageTitle: "Go to next",
    firstPageTitle: "Go to first",
    lastPageTitle: "Go to Last",
    sizePerPageList: [
      { text: "10", value: 10 },
      { text: "30", value: 30 },
      { text: "50", value: 50 },
      { text: "100", value: 100 },
      { text: "All", value: filteredData?.length || 100 },
    ],
    custom: true,
  };

  return (
    <>
      <div className="position-relative">
        <div
          className={`container-fluid bg-white ${
            isLoading ? "blur-background" : ""
          }`}
        >
          <ReportsCriteria
            reportName="Customer Balances GL Report"
            lovs={["fromDate", "toDate", "fromCust", "toCust", "custCateg", "branchmore"]}
            isMulti={false}
            companyId={companyId}
            token={token}
            callBack={handleDynamicColapse}
            username={username}
            handleFind={(p) => handleFind(p)}
            table={table.OverViewDataTable}
            sendSearchedData={sendSearchedData}
            todaysDate={true}
          />

          <Collapse isOpen={data.collapseCriteria}>
            <div className="row float-right pr-4 mb-2">
              <Button
                color="secondary"
                className="button-22"
                onClick={() => graph()}
                id="invoiceButton"
              >
                Graph
              </Button>
              <Decimal
                showAsInteger={showAsInteger}
                onToggle={setShowAsInteger}
              />
              <Button
                color="success"
                className="button-22 "
                onClick={() =>
                  funPrintView(
                    table.printData,
                    table.listOfColLables,
                    table.listOfColKey
                  )
                }
                id="invoiceButton"
              >
                Print
              </Button>

              <ExportToExcel
                Data={table.exportData}
                listOfColKey={table.listOfColKey}
                DynamicReports={true}
                ReportName="Customer Balances GL Report"
                criteriaString={data.criteriaString}
              />
            </div>
          </Collapse>
          {showtable && (
            <div translate="no" className="mt-5">
              <div className="sticky-table-wrapper">
                <div className="sticky-table-container">
                  <PaginationProvider pagination={paginationFactory(options)}>
                    {({ paginationProps, paginationTableProps }) => (
                      <div>
                        {/* TOP Pagination Controls */}
                        <div className="d-flex justify-content-between align-items-center my-2">
                          <SizePerPageDropdownStandalone {...paginationProps} />
                        </div>

                        <BootstrapTable
                          key={`${showAsInteger}`}
                          keyField="sr"
                          data={filteredData}
                          columns={columns}
                          headerClasses="rpr_header"
                          bodyClasses="rpr_body"
                          containerClass="rpr_container"
                          striped
                          condensed
                          hover
                          {...paginationTableProps}
                        />
                      </div>
                    )}
                  </PaginationProvider>
                </div>
              </div>
            </div>
          )}
        </div>
        {isLoading && (
          <div className="loader-overlay">
            <div className="spinner-border text-primary" role="status">
              <span className="sr-only">Loading...</span>
            </div>
          </div>
        )}
      </div>
    </>
  );
}
